<template>
  <!-- Authors Table Card -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: 0 }"
  >
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">部门管理·数据表格</h5>
        </a-col>
      </a-row>
    </template>
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form
          layout="inline"
          :form="dataForm"
          @submit="getDataList"
          class="ml-20"
        >
          <a-form-item>
            <a-button type="primary" @click="getDataList">刷新</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()"
              >新增部门</a-button
            >
          </a-form-item>
        </a-form>

        <a-table
          :columns="columns"
          :data-source="dataList"
          :pagination="false"
          rowKey="department_id"
          :loading="dataListLoading"
          :defaultExpandAllRows="true"
        >
          <template slot="department_leader" slot-scope="department_leader">
            <div class="author-info">
              <h6 class="m-2">{{ department_leader }}</h6>
            </div>
          </template>

          <template slot="department_phone" slot-scope="department_phone">
            <div class="author-info">
              <h6 class="m-2">{{ department_phone }}</h6>
              <p class="m-0 font-regular text-muted"></p>
            </div>
          </template>

          <template slot="editBtn" slot-scope="text, row">
            <a-button
              type="link"
              class="btn-edit"
              @click="addOrUpdateHandle(row.department_id)"
            >
              编辑
            </a-button>
            <a-button
              type="link"
              class="btn-edit"
              @click="deleteHandle(row.department_id)"
            >
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      allowClear: false,
      mixinViewModuleOptions: {
        createdIsNeed: true,
        getDataListIsPage: false,
        getDataListURL: "/admin/department/page",
        deleteURL: "/admin/department/delete",
      },
      dataForm: {},
      columns: [
        {
          title: "部门名称",
          dataIndex: "department_name",
          class: "font-regular",
        },
        {
          title: "部门负责人",
          dataIndex: "department_leader",
          scopedSlots: { customRender: "department_leader" },
        },
        {
          title: "负责人联系方式",
          dataIndex: "department_phone",
          scopedSlots: { customRender: "department_phone" },
        },
        {
          title: "创建时间",
          dataIndex: "department_createtime",
          class: "text-muted",
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  methods: {},
};
</script>